import React, { useEffect, useState } from 'react';
import { Megaphone, X, Pin } from 'lucide-react';
import { api } from '@/lib/api';

const STORAGE_KEY = 'indivalife.dismissed_announcements';

const KIND_ICON = { update: '📣', trip: '✈️', prize: '🏆', winner: '🥇' };
const KIND_TINT = {
  update: { bg: '#E0F2FE', fg: '#075985' },
  trip: { bg: '#FEF3C7', fg: '#92400E' },
  prize: { bg: '#FCE7F3', fg: '#9D174D' },
  winner: { bg: '#DCFCE7', fg: '#1E3A8A' },
};

const loadDismissed = () => {
  try { return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')); }
  catch { return new Set(); }
};
const saveDismissed = (set) => localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));

export const AnnouncementsBanner = () => {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(loadDismissed());

  useEffect(() => {
    api.get('/announcements').then(r => setItems(r.data || [])).catch(() => {});
  }, []);

  const dismiss = (id) => {
    const next = new Set(dismissed); next.add(id);
    setDismissed(next); saveDismissed(next);
  };

  const visible = items.filter(a => !dismissed.has(a.announcement_id));
  if (visible.length === 0) return null;

  return (
    <div className="space-y-2 mb-4" data-testid="announcements-banner">
      {visible.map(a => {
        const tint = KIND_TINT[a.kind] || KIND_TINT.update;
        return (
          <div
            key={a.announcement_id}
            className="rounded-xl px-4 py-3 flex items-start gap-3 shadow-sm border"
            style={{ background: tint.bg, borderColor: `${tint.fg}33`, color: tint.fg }}
            data-testid={`ann-${a.announcement_id}`}
          >
            <div className="text-2xl shrink-0 select-none">{KIND_ICON[a.kind] || '📣'}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                {a.pinned && <Pin className="h-3 w-3" />}
                <div className="font-bold text-sm">{a.title}</div>
              </div>
              {a.body && <div className="text-[13px] mt-0.5 whitespace-pre-wrap" style={{ color: tint.fg }}>{a.body}</div>}
              {a.image_url && <img src={a.image_url} alt="" className="mt-2 rounded-lg max-h-32 object-cover" />}
              <div className="text-[10px] opacity-60 mt-1">{new Date(a.created_at).toLocaleString()}</div>
            </div>
            <button onClick={() => dismiss(a.announcement_id)} className="opacity-60 hover:opacity-100" aria-label="Dismiss" data-testid={`ann-dismiss-${a.announcement_id}`}>
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default AnnouncementsBanner;
